'use client';
import { Redirect } from '@/components/Redirect';

export default Redirect;
